import Swipe from './swipe'

const innerContentScroller = (direction, distance, box) => {
  if ('left' === direction) {
    box.scrollLeft += distance
  } else if ('right' === direction) {
    box.scrollLeft -= distance
  }
}

const ZERO = 0

export default function sliderControl(className = 'slider-box') {
  const initSliders = (sliderClass = 'fake-slider') => {
    const boxes = [...document.getElementsByClassName(className)];

    boxes.forEach(parent => {
      const [box] = parent.getElementsByClassName(sliderClass)

      if (box) {
        const isTouchDevice = navigator.maxTouchPoints > ZERO || navigator.msMaxTouchPoints > ZERO

        if (!isTouchDevice) {
          const swipe = new Swipe(box, {
            corners: true,
            minDistance: 200,
          })

          swipe.addEventListener('live', (direction, distance) => {
            innerContentScroller(direction, distance, box)
          })
        }

        const [controls] = parent.getElementsByClassName('snap-controls')

        if (controls) {
          const arrows = [...controls.children]

          const [prev, next] = arrows

          arrows.forEach(arr => {
            const direction = arr.dataset.snapSliderGoto
            const distance = box.firstChild?.clientWidth || box.clientWidth

            arr.addEventListener('click', () => {
              arrows.forEach(arrow => arrow.classList.remove('is-disabled'))

              innerContentScroller(direction, distance, box)

              setTimeout(() => {
                if (!box.scrollLeft) {
                  prev.classList.add('is-disabled')
                }
                if (box.scrollLeft + box.clientWidth >= (box.scrollWidth - 60)) {
                  next.classList.add('is-disabled')
                }
              }, 600)
            })

            setTimeout(() => {
              if (box.scrollLeft + box.clientWidth >= (box.scrollWidth - 65)) {
                if (next) next.classList.add('is-disabled')

                return
              }

              if (next) next.classList.remove('is-disabled')
            })
          })
        }
      }
    })
  }

  const tabs = [...document.getElementsByClassName('js-tab-slider')]
  const productTabs = [...document.getElementsByClassName('js-tab-slider-product')]

  tabs.forEach(t => {
    t.addEventListener('click', () => {
      initSliders()
    })
  })

  productTabs.forEach(t => {
    t.addEventListener('click', () => {
      initSliders('js-tabs-slider')
    })
  })

  setTimeout(() => {
    initSliders()
  }, 100)
}
